module.exports = __webpack_public_path__ + "media/images/lp_v6_yt-58db49f0d5b3c38ad2b078de55e6d50a.webp";